<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 28 33.621">
        <g id="Group_2826" data-name="Group 2826" transform="translate(-24 -476)">
            <circle id="Ellipse_185" data-name="Ellipse 185" cx="14" cy="14" r="14" transform="translate(24 476)"
                    fill="#cedbff"/>
            <g id="tourism" transform="translate(-55.258 484.38)">
                <path id="Path_70014" data-name="Path 70014"
                      d="M104.645,21.807a.37.37,0,0,0,.37-.37V.37a.37.37,0,0,0-.37-.37h-2.723a.37.37,0,1,0,0,.739h2.353V21.067H94.044a.37.37,0,0,0,0,.739H98.1v1.213H89.846a.606.606,0,1,1,0-1.213h2.478a.37.37,0,0,0,0-.739H91.2V.739h9.01a.37.37,0,0,0,0-.739H89.846A1.347,1.347,0,0,0,88.5,1.346V22.413a1.347,1.347,0,0,0,1.346,1.346H98.1v1.112a.37.37,0,0,0,.543.327l1.128-.6,1.128.6a.37.37,0,0,0,.543-.327V23.759h3.209a.37.37,0,0,0,0-.739h-.37V21.807ZM89.846.739h.616V21.067h-.616a1.338,1.338,0,0,0-.606.144V1.346a.607.607,0,0,1,.606-.606ZM100.7,24.257l-.758-.4a.37.37,0,0,0-.346,0l-.758.4V21.807H100.7Zm2.839-1.238h-2.1V21.807h2.1Z"
                      fill="#799cfb"/>
                <path id="Path_70015" data-name="Path 70015"
                      d="M204.374,324.969a.37.37,0,0,0-.37-.37h-6.9a.37.37,0,1,0,0,.739H204A.37.37,0,0,0,204.374,324.969Z"
                      transform="translate(-102.897 -308.597)" fill="#799cfb"/>
                <path id="Path_70016" data-name="Path 70016"
                      d="M231.993,354.62a.37.37,0,1,0,0,.739h3.462a.37.37,0,1,0,0-.739Z"
                      transform="translate(-136.067 -337.138)" fill="#799cfb"/>
                <path id="Path_70017" data-name="Path 70017"
                      d="M186.913,70.454a4.529,4.529,0,0,0-1.381,8.841l1.049,2.133a.37.37,0,0,0,.663,0l1.049-2.133a4.529,4.529,0,0,0-1.381-8.841Zm1.021,8.177a.37.37,0,0,0-.232.193l-.789,1.6-.789-1.6a.37.37,0,0,0-.232-.193,3.788,3.788,0,1,1,2.042,0Z"
                      transform="translate(-89.257 -66.981)" fill="#799cfb"/>
                <path id="Path_70018" data-name="Path 70018"
                      d="M235.777,121.852a1.994,1.994,0,1,0,1.994,1.994A2,2,0,0,0,235.777,121.852Zm0,3.249a1.255,1.255,0,1,1,1.255-1.255A1.256,1.256,0,0,1,235.777,125.1Z"
                      transform="translate(-138.121 -115.845)" fill="#799cfb"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IGuide",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
